export default __webpack_public_path__ + "static/media/tunnel.f5aba0bd.jpg";